<div
  (click)="reducedSummary && openAutomations()"
  class="promotion-card"
  style="
    flex: 0 0 auto;
    border-radius: 10px;
    background-color: white;
    padding: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  "
  [ngStyle]="
    reducedSummary
      ? { width: '175px', cursor: 'pointer' }
      : { width: '350px', cursor: 'default' }
  "
>
  <div
    class="form-field-label"
    style="font-weight: 600; font-size: 15px; margin-bottom: 8px"
  >
    {{ getPromoTitle(promo) }}
  </div>

  <div
    class="form-field-label"
    style="font-weight: 400; font-size: 14px; color: #555"
  >
    {{ getPromoSummary(promo) }}
  </div>

  <div
    style="display: flex; justify-content: space-between; align-items: center"
  >
    <div
      class="form-field-label"
      style="font-weight: 400; font-size: 14px; color: #555; margin-bottom: 0px"
      *ngIf="leading"
    >
      {{ leading.label }}
      <b>{{ leading.time }}</b>
    </div>

    <app-secondary-button
      *ngIf="buttonTitle"
      style="margin-left: 10px"
      [title]="buttonTitle"
      (tapped)="deletePromotion.emit(promo)"
    ></app-secondary-button>
  </div>
</div>
